module.exports = "/images/cellphone.svg?111fe1412e08f8037f9d8c02e3096ba7";